export enum DashboardLoaderKey {
  GET_GUEST_EMISSIONS = 'get-guest-emissions',
  GET_TASKS = 'get-tasks'
}

export enum TaskStatus {
  FAILED = 'Failed',
  NOT_REPORTED = 'Not Reported'
}
